import { Component, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { GenericService } from '../../generic.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiComponentServices } from '../../services/api-services';
import { DishMachineOption } from '../../models/accountData';
import { LandingService } from '../../landing-page/service/landing.service';
import { MachineType } from '../../landing-page/service/machineType';
import { Subscription } from 'rxjs';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';
declare var $: any;

@Component({
    selector: 'app-account-details',
    imports: [FormsModule, ReactiveFormsModule, CommonModule],
    templateUrl: './account-details.component.html',
    styleUrls: ['./account-details.component.scss']
})
export class AccountDetailsComponent {
  accountForm!: FormGroup;
  deviceData: any = {};
  deviceData$: any = null;
  isEdit: boolean = true;
  accountNumber: string = '';
  accountKey: string = '';
  accountDetails: any = {};
  isAccountValid: boolean = false;
  mapAccount: any = {};
  qrId: any;
  errorMessage: string = '';
  scanEnable: boolean = false;
  // @ViewChild(ScanQrCodeComponent) scanQrCodeComponent!: ScanQrCodeComponent;
  receivedData: string = '';
  machineType = MachineType;
  dishmachineOptions: DishMachineOption[] = [];

  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private genericService: GenericService,
    private router: Router,
    private fb: FormBuilder,
    private apiService: ApiComponentServices,
    private landingService: LandingService,
    private route: ActivatedRoute,
    private crowdinService: CrowdinService,
  ) {
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
        this.accountNumber = this.deviceData.accountNumber;
        this.qrId = this.route.snapshot.paramMap.get('qrId');
      }
    });
  }

  ngOnInit() {
    this.getAccountData(this.accountNumber, this.qrId, this.accountKey);
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
    this.createForm();
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  createForm() {
    this.accountForm = this.fb.group({
      accountNumber: new FormControl(this.deviceData.accountNumber),
      accountName: new FormControl(this.accountDetails?.AccountName),
      address: new FormControl(this.accountDetails?.Address),
      city: new FormControl(this.accountDetails?.City),
      state: new FormControl(this.accountDetails?.State),
      zip: new FormControl(this.accountDetails?.ZipCode),
      dishmachine: new FormControl(null),
    });
  }

  // Getters for form controls
  get accountId() {
    return this.accountForm.get('accountNumber') as FormControl;
  }
  get accountName() {
    return this.accountForm.get('accountName') as FormControl;
  }
  get state() {
    return this.accountForm.get('state') as FormControl;
  }
  get city() {
    return this.accountForm.get('city') as FormControl;
  }
  get zip() {
    return this.accountForm.get('zip') as FormControl;
  }
  get address() {
    return this.accountForm.get('address') as FormControl;
  }
  get dishmachine() {
    return this.accountForm.get('dishmachine') as FormControl;
  }

  onEditClick() {
    this.accountDetails = null;
    this.isAccountValid = true;
    this.isEdit = true;
  }

  onCancelClick() {
    this.isEdit = false;
    this.isAccountValid = false;
  }

  onVerifyAccountClick() {
    const account = document.getElementById(
      'accountNumber',
    ) as HTMLInputElement;
    if (account.value) {
      this.accountNumber = account.value;
      this.getAccountData(account.value, this.qrId, this.accountKey);
      this.genericService.setLocalStorage(this.deviceData);
      this.genericService.deviceData.next(this.deviceData);
    }
  }

  onNextClick() {
    const accountNumber = this.accountId.value;
    this.mapAccountData();
    this.apiService.mapAccountWithQRData(this.mapAccount).subscribe(
      (response) => {
        if (response) {
        }
        this.updateAccountData();
        this.router.navigate([`troubleshoot/${accountNumber}`]);
      },
      (error) => {
        this.errorMessage = error.error;
        $('#messageModal').modal('show');
      },
    );
  }

  getAccountData(accountNumber: string, qrId: string, accountKey: string) {
    if (accountNumber) {
      this.apiService.getAccountData(accountNumber, qrId, accountKey).subscribe(
        (response) => {
          if (response) {
            this.accountDetails = response;

            this.updateDishMachineOptions(response.Devices);

            // Get the first device type as the selected dishmachine value
            const dishmachineValue = response.Devices?.length
              ? response.Devices[0].MachineName
              : null;

            // Patch the form with the account details and dishmachine value
            this.accountForm.patchValue({
              accountNumber: this.accountDetails.AccountNumber,
              accountName: this.accountDetails.AccountName,
              address: this.accountDetails.Address,
              city: this.accountDetails.City,
              state: this.accountDetails.State,
              zip: this.accountDetails.ZipCode,
              dishmachine: dishmachineValue,
            });

            this.isAccountValid = true;
            this.isEdit = false;
          } else {
            this.resetForm();
          }
        },
        (error) => {
          console.error('Error fetching account data', error);
          this.resetForm();
        },
      );
    }
  }

  updateDishMachineOptions(devices: any[]) {
    this.dishmachineOptions = [];

    if (devices && devices.length > 0) {
      devices.forEach((device) => {
        const machineType = device.MachineType;
        const machineMap = this.landingService.getMachineTypeMap();

        const mapped = machineMap[machineType];

        if (mapped) {
          this.dishmachineOptions.push({
            value: device.MachineName,
            label: mapped.label,
            image: mapped.image,
            type: mapped.type,
            deviceType: machineType,
          });
        }
      });
    } else {
      this.dishmachineOptions = [];
    }
  }

  getAccountDataByQRId(
    qrId: string,
    accountNumber: string,
    accountKey: string,
  ) {
    if (qrId && accountNumber) {
      this.apiService.getAccountData(accountNumber, qrId, accountKey).subscribe(
        (response) => {
          if (response) {
            this.accountDetails = response;

            if (this.accountDetails?.AccountNumber) {
              // Get the first device type from the response
              const dishmachineValue = response.Devices?.length
                ? response.Devices[0].MachineName
                : null;

              this.accountForm.patchValue({
                accountNumber: this.accountDetails.AccountNumber,
                accountName: this.accountDetails.AccountName,
                address: this.accountDetails.Address,
                city: this.accountDetails.City,
                state: this.accountDetails.State,
                zip: this.accountDetails.ZipCode,
                dishmachine: dishmachineValue,
              });

              this.isAccountValid = true;
            } else {
              this.resetForm();
            }
          } else {
            this.resetForm();
          }
        },
        (error) => {
          console.error('Error fetching account data', error);
          this.resetForm();
        },
      );
    } else {
      console.error('QR ID or Account Number is missing');
    }
  }

  private resetForm() {
    this.isAccountValid = false;
    this.accountDetails = null;
    this.accountForm.patchValue({
      accountNumber: this.accountNumber,
      accountName: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      dishmachine: '',
    });
  }

  fillAccountData() {
    if (this.accountDetails) {
      this.accountName.setValue(this.accountDetails.AccountName);
      this.address.setValue(this.accountDetails.Address);
      this.state.setValue(this.accountDetails.State);
      this.city.setValue(this.accountDetails.City);
      this.zip.setValue(this.accountDetails.ZipCode);
      this.dishmachine.setValue(this.accountDetails.Dishmachine);
    } else {
      this.accountName.setValue('');
      this.address.setValue('');
      this.state.setValue('');
      this.city.setValue('');
      this.zip.setValue('');
      this.dishmachine.setValue('');
    }
  }

  onAccountNumberEntry(event: any) {
    this.accountDetails = null;
    this.fillAccountData();
    this.isAccountValid = event?.target?.value?.length === 10;
  }

  validateLength(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    if (
      input.value.length >= 10 ||
      event.key === '.' ||
      event.key === '-' ||
      event.key === '+'
    ) {
      event.preventDefault();
    }
  }

  // openScanner() {
  //   this.scanEnable = true;
  // }

  closeScanner() {
    this.scanEnable = false;
  }

  // handleData(data: string = '1234567899') {
  //   this.receivedData = data;
  //   this.accountNumber = data; // Updated account number after scanning
  //   this.qrId = localStorage.getItem('qrId');

  //   // Check if QR ID exists in localStorage
  //   if (this.qrId) {
  //     this.getAccountDataByQRId(this.qrId, this.accountNumber, this.accountKey);
  //   } else {
  //     console.error('QR ID not found in local storage');
  //   }

  //   this.closeScanner();
  // }

  updateAccountData() {
    this.deviceData['accountNumber'] = this.accountNumber;
    this.deviceData['businessName'] = this.accountDetails?.AccountName;
    this.deviceData['address'] = this.accountDetails?.Address;
    this.deviceData['city'] = this.accountDetails?.City;
    this.deviceData['state'] = this.accountDetails?.State;
    this.deviceData['zip'] = this.accountDetails?.ZipCode;
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
  }

  setLocalStorage(accountDetails: any) {
    if (accountDetails.AccountNumber) {
      localStorage.setItem('accountNumber', accountDetails.AccountNumber);
    }

    if (accountDetails.AccountName) {
      localStorage.setItem('accountName', accountDetails.AccountName);
    }

    if (accountDetails.State) {
      localStorage.setItem('state', accountDetails.State);
    }

    if (accountDetails.zip) {
      localStorage.setItem('zip', accountDetails.zip);
    }

    if (accountDetails.Devices && Array.isArray(accountDetails.Devices)) {
      const deviceNames = accountDetails.Devices.map(
        (device: { MachineName: any }) => device.MachineName,
      );
      localStorage.setItem('machineModels', JSON.stringify(deviceNames));
    } else {
      localStorage.setItem('machineModels', JSON.stringify([]));
    }
  }

  mapAccountData() {
    this.mapAccount.AccountNumber = this.accountNumber;
    this.mapAccount.QRId = this.deviceData?.QRId;
    this.mapAccount.Category = 'Dishmachine';
    this.mapAccount.CategoryType = this.machineType.EHT;
  }

  ngOnDestroy(): void {
    if (this.deviceData$) {
      this.deviceData$.unsubscribe();
    }
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService?.setLocalStorage(this.deviceData);
    this.genericService?.deviceData.next(this.deviceData);
  }

  goBack() {
    this.deviceData['languageSelected'] = this.currentLanguage;
    this.genericService.setLocalStorage(this.deviceData);
    this.genericService.deviceData.next(this.deviceData);
    history.go(-1);
  }
}
